import { render, staticRenderFns } from "./CollectionBackPerformanceZuzhang.vue?vue&type=template&id=bab6fa0e&scoped=true"
import script from "./CollectionBackPerformanceZuzhang.vue?vue&type=script&lang=js"
export * from "./CollectionBackPerformanceZuzhang.vue?vue&type=script&lang=js"
import style0 from "./CollectionBackPerformanceZuzhang.vue?vue&type=style&index=0&id=bab6fa0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab6fa0e",
  null
  
)

export default component.exports